// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"378":"521116ce","788":"b00b0cd0","854":"9bab99fb"}[chunkId] + ".chunk.css";
};